<ion-header mode="ios">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="closePage()">
        <ion-icon [src]="'/assets/icons/' + capacitor.scheme + '/x.svg'"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ capacitor.translateString('Terms') }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding www">
  <ion-grid>
    <h1>{{ capacitor.translateString('Terms') }}</h1>
    <p><strong>Last update: 8 April 2025</strong></p>

    <p>
      The service “iBucket” is offered over the internet by&nbsp;<a
        href="https://kaimallie.com/"
        target="_blank"
        >Kai Mallie</a
      >. The use of iBucket is subject to the below terms and conditions. Using iBucket constitutes
      acceptance of these terms and conditions. Deviations from these terms and conditions is
      possible only by means of written confirmation by iBucket.
    </p>

    <h3 class="wp-block-heading">Terms of Use</h3>

    <p><strong>Article 1. Use of the service</strong></p>

    <ul class="wp-block-list">
      <li>
        The service iBucket allows you to publish a profile for yourself and get in contact with
        other users. iBucket does not actively assist in doing so but does moderate to ensure the
        service is used legally and appropriately.
      </li>

      <li>
        To use iBucket, you can create a free account. After completing registration, you can
        directly log into your account and use the service on other devices.
      </li>

      <li>
        You must secure access to your account against third parties. iBucket may assume that all
        actions undertaken from your account after logging in with your email is authorised and
        supervised by you. This means you are liable for these actions, unless and until you have
        notified iBucket that someone else has access to your mailbox.
      </li>

      <li>
        iBucket processes your personal data. You give your consent for all forms of processing
        within the scope of the service. Consult the privacy statement of iBucket for more
        information.
      </li>
    </ul>

    <p><strong>Article 2. Terms of use</strong></p>

    <ul class="wp-block-list">
      <li>
        It it is not permitted to use iBucket for any purpose that violates Dutch or other
        applicable law or regulation. This includes (among others) the storage or transmission of
        data using the service that is slanderous, libellous or racist, or to create profiles on
        iBucket under the names of other people or to pretend to be another person, or a
        moderator/maintainer of iBucket.
      </li>

      <li>
        In addition, on iBucket it is forbidden to
        <ul class="wp-block-list">
          <li>use indecent language;</li>

          <li>publish information where it is unwanted (offtopic);</li>

          <li>
            publish information that is pornographic or erotic (even if legal under applicable law);
          </li>

          <li>publish information in violation of copyright or hyperlinks to such information;</li>

          <li>
            assist others in violating third-party rights, for example by linking to hacking tools
            or tutorials for committing computer crime that are clearly written to carry out
            criminal acts (and not to defend against them);
          </li>

          <li>
            violate the privacy of third party, for example by distributing their personal data
            without permission or clear need or the repeated harassment of third parties with
            unwanted communications;
          </li>

          <li>exercise commercial activities;</li>

          <li>and to do anything that violates applicable netiquette.</li>
        </ul>
      </li>

      <li>
        Should iBucket discover that you violate any of the above, or receive a complaint alleging
        the same, then iBucket may intervene to end the violation.
      </li>

      <li>
        If in the opinion of iBucket the continued functioning of the computer systems or network of
        iBucket or third parties is actually or under threat of being damaged or jeopardized, for
        example through excessive transmission of e-mail or other data, leaks of personal data or
        virus activity, iBucket may take all steps it deems reasonably necessary to end or avert
        such damage or jeopardy. iBucket in particular is entitled to change your contributions at
        its own discretion.
      </li>

      <li>
        iBucket is at all times entitled to file a criminal complaint for any offenses committed
        through or using the service.
      </li>

      <li>
        iBucket may recoup from you all damages it suffers as a result of your violation of these
        terms of use. You agree and hold harmless iBucket from all third-party claims arising out of
        your violation of these terms of use.
      </li>

      <li>
        iBucket is allowed at any moment to edit or delete content or set your profile on private
        when it violates with our terms of use.
      </li>
    </ul>

    <p><strong>Article 3. Availability and maintenance</strong></p>

    <ul class="wp-block-list">
      <li>iBucket guarantees availability of the service 99% of the time.</li>

      <li>
        iBucket actively maintains iBucket. In case maintenance is reasonably expected to negatively
        impact availability, iBucket carry out such maintenance at times when use of the service is
        relatively low. Maintenance is announced in advance whenever possible. Emergency maintenance
        can take place at any time and without prior announcement.
      </li>

      <li>
        iBucket may from time to time adapt feedback. Your feedback and suggestions are welcome but
        ultimately iBucket decides which adaptations to carry out (or not). iBucket shall announce
        planned adaptations at least thirty days in advance.
      </li>
    </ul>

    <p><strong>Article 4. Intellectual property</strong></p>

    <ul class="wp-block-list">
      <li>
        The service iBucket, the accompanying software as well as all information and images on the
        website is the intellectual property of iBucket. None of these items may be copied or used
        without prior written permission of iBucket, except and to the extent permitted by mandatory
        law.
      </li>

      <li>
        Information you store or process using the service is and remains your property (or the
        property of your suppliers or licensors). iBucket receives a limited license to use this
        information for the service.
      </li>

      <li>
        You can terminate the license of the previous clause by removing the information in question
        and/or to terminate the agreement.
      </li>

      <li>
        You may change or remove information you publish or store using the service at your own
        discretion.
      </li>

      <li>
        If you send information to iBucket, for example a bug report or suggestion for improvement,
        you grant iBucket a perpetual and unlimited license to use this information for the service.
        This does not apply to information you expressly mark as confidential.
      </li>

      <li>
        iBucket shall refrain from accessing data you store or transfer using iBucket, unless this
        is necessary for a good provision of the service or iBucket is forced to do so by law or
        order of competent authority. In these cases iBucket shall use its best efforts to limit
        access to the information as much as possible.
      </li>
    </ul>

    <p><strong>Article 5. Compensation for the service</strong></p>

    <ul class="wp-block-list">
      <li>iBucket is offered completely at no charge.</li>
    </ul>

    <p><strong>Article 6. Limitation of liability</strong></p>

    <ul class="wp-block-list">
      <li>
        Except in case of intentional misconduct or gross negligence iBucket shall not be liable for
        the use of the service or any damages in connection therewith.
      </li>

      <li>
        iBucket in no event is liable for indirect damages, consequential damages, lost profits,
        missed savings or damages through business interruption.
      </li>

      <li>
        Damages may only be claimed if reported in writing to iBucket at most two months after
        discovery.
      </li>

      <li>
        In case of force majeure iBucket is never required to compensate damages suffered by you.
        Force majeure includes among others disruptions or unavailability of the internet,
        telecommunication infrastructure, power interruptions, riots, traffic jams, strikes, company
        disruptions, interruptions in supply, fires and floods.
      </li>
    </ul>

    <p><strong>Article 7. Term and termination</strong></p>

    <ul class="wp-block-list">
      <li>
        This agreement enters into force as soon as you first use the service and then remains in
        force until terminated.
      </li>

      <li>
        If you entered into this agreement as a consumer, you may terminate the agreement at any
        time with a notice period of one month, calculated from the moment of the notice.
        Non-consumers can terminate the agreement with a notice period of two months.
      </li>

      <li>
        iBucket is entitled to terminate the agreement if you have not used the service at all in
        the last 18 months. In such an event iBucket shall first send a reminder mail to the e-mail
        address connected to your account.
      </li>
    </ul>

    <p><strong>Article 8. Changes to terms</strong></p>

    <ul class="wp-block-list">
      <li>
        iBucket may change or add to these terms and conditions as well as any prices at any time.
      </li>

      <li>
        iBucket shall announce through the service changes or additions at least thirty days before
        their taking effect.
      </li>

      <li>
        If you do not want to accept a change or addition, you can terminate the agreement until the
        date the changes take effect. Use of iBucket after the date of effect shall constitute your
        acceptance of the changed or added-to terms and conditions.
      </li>
    </ul>

    <p><strong>Article 9. Miscellaneous provisions</strong></p>

    <ul class="wp-block-list">
      <li>Dutch law applies to this agreement.</li>

      <li>
        Except to the extent determined otherwise by mandatory applicable law all disputes arising
        in connection with iBucket shall be brought before the competent Dutch court for the
        principal place of business of iBucket.
      </li>

      <li>
        For any clause in these terms and conditions that demand that a statement must be done “in
        writing” to be legally valid, a statement by e-mail or communication through the iBucket
        service shall be sufficient provided with sufficient certainty the authenticity of the
        sender can be established and the integrity of the statement has not been compromised.
      </li>

      <li>
        The version of any communication of information as recorded by iBucket shall be deemed to be
        authentic, unless you supply proof to the contrary.
      </li>

      <li>
        In case any part of these terms and conditions are declared legally invalid, this shall not
        affect the validity of the whole of the agreement. The parties shall in such an event agree
        on one or more replacement provisions that approximate the original intent of the invalid
        provision(s) within the limits of the law.
      </li>

      <li>
        iBucket is entitled to transfer its rights and obligations under this agreement to a third
        party as part of an acquisition of iBucket or the associated business activities.
      </li>
    </ul>

    <h3 class="wp-block-heading">End User License Agreement</h3>

    <p>
      <strong>Scope of the license</strong><br />iBucket hereby grants to the legitimate acquirer of
      iBucket (“you”) a usage right for this App. This license is personal. The App may be used only
      on the device onto which the App was downloaded and installed. The purpose of the App is to
      provide a social networking service, while users are of course free to use iBucket for any
      purpose within the boundaries of these terms and conditions and the law.
    </p>

    <p>It is not permitted</p>

    <ul class="wp-block-list">
      <li>
        to decompile or reverse engineer the source code of the App, except to the extent permitted
        by mandatory law or applicable open source license;
      </li>

      <li>to supply copies of the App to third parties;</li>

      <li>
        to sublicense the App or to make the App available to third parties, by rental,
        Software-as-a-Service constructs or otherwise;
      </li>

      <li>to modify the App, except to the extent permitted by mandatory law;</li>

      <li>to remove or make unreadable notices of iBucket as copyright holder of the App.</li>
    </ul>

    <p>
      You may make a backup copy of the App. You may however not use the backup copy on its own or
      distribute the same other than in combination with the original App. In addition to the terms
      and conditions of the present document Apple’s App Store and Google’s Play Store may set terms
      for the acquisition and use of the App, the making of in-app purchases and related matters. To
      find out more, see the terms of use and privacy statement of Apple’s App Store and Google’s
      Play Store, and other terms and conditions identified on the website of this third party.
    </p>

    <p>
      <strong>Intellectual property</strong><br />All rights to the App, accompanying documentation
      and all modifications and extensions thereto rest and remain with iBucket. You only acquire
      those rights and permissions that follow from this agreement or those that are granted
      separately in writing. You may not use, copy or publish the App except as permitted. The App
      contains open source software from third parties. Their respective rights holders grant you a
      usage right under the applicable open source licenses. These are included in the
      documentation. This end user license agreement does not apply to this open source software,
      and nothing in this end user license agreement shall be construed as limiting or contradicting
      any right granted to you under an applicable open source license.
    </p>

    <p><strong>Consideration</strong><br />The usage right is granted at no charge.</p>

    <p>
      <strong>In-app purchases</strong><br />iBucket allows the making of purchases within the
      context of the App. To make such in-app-purchases, iBucket is dependent on the payment system
      operated by “Apple Inc.”, “Google Inc.” and “Stripe Inc.”, including the underlying payment
      systems from e.g. credit card processors. iBucket is only required to effectuate an in-app
      purchase when this payment system has confirmed payment. As to in-app purchases you
      acknowledge that there is no right to revoke or cancel the purchase under the Distance Selling
      Act. In-app purchases may have the purpose to extend the functionalities of the App. These
      upgrades are a one-time acquisition.
    </p>

    <p>
      <strong>Personal data</strong><br />The App processes your personal data. For more information
      consult the privacy statement, please visit
      <a href="https://ibucket.app/privacy" target="_blank">https://ibucket.app/privacy</a>.
    </p>

    <p>
      <strong>Affiliates</strong><br />Occasionally, at our discretion, we may include or offer
      third party products, blogs, tickets or services on our website and app. These third party
      sites have separate and independent terms of service. We therefore have no responsibility or
      liability for the content and activities of these linked sites. Nonetheless, we seek to
      protect the integrity of our site and welcome any feedback about these sites.
    </p>

    <p>
      <strong>Updates</strong><br />iBucket periodically releases updates that may fix bugs or
      improve the functioning of the App. Available updates shall be notified to you through
      notifications provided by Apple’s App Store and Google’s Play Store, but it is your
      responsibility to monitor these notifications. Updates are applied similarly through these
      platforms, which requires an active internet connection. Installing updates requires your
      separate consent. A proper application of updates requires the availability and good
      functioning of Apple’s App Store and Google’s Play Store, over which iBucket has no control.
      iBucket is not responsible or liable for an incorrect execution of updates. No liability
      exists for any damage as a result of bugs fixed in an update you did not install. An update
      can set terms additional to or different from the present document. You will be notified in
      advance and you will be allowed to refuse such updates. Installing such an update constitutes
      your acceptance of the additional or different terms, which shall then be incorporated into
      this agreement.
    </p>

    <p>
      <strong>Support</strong><br />You are solely responsible for installing and activating the App
      and the accompanying Web service. You can provide feedback about the App via Apple’s App Store
      and Google’s Play Store, after which iBucket shall evaluate your feedback and contact you if
      necessary.
    </p>

    <p>
      <strong>Guarantees and liability</strong><br />iBucket guarantees that iBucket contains no
      viruses, backdoors or malicious routines; that iBucket violates no third-party rights (such as
      copyrights), excluding any violations arising out of a particular use of the App; it will use
      its best efforts to investigate any reported bugs as soon as is practical and to repair such
      bug or create a workaround( iBucket may delay repairing bugs with limited impact until the
      next planned update); but nothing else. Except in cases of intentional misconduct or gross
      negligence or the violation of a warranty granted above iBucket is not liable towards you,
      regardless of ground, for any damages in connection with iBucket. No liability exists in case
      damages were not reported timely after discovery to iBucket. In addition no liability exists
      if the cause of damage is beyond the control of iBucket (force majeure). The App communicates
      via the internet with a server under control of iBucket to provide the complete service.
      iBucket uses its best efforts to have this server available at all times, but makes no
      guarantees in this regard. From time to time iBucket can make updates to the server, which may
      lead to a temporary unavailability. iBucket will do its best to inform you in advance about
      unavailability. Everything in this document regarding updates, support and liability applies
      equally to the server. No liability exists for damages directly or indirectly resulting from
      incorrect functioning of Apple’s Appstore.
    </p>

    <p>
      <strong>Term of the agreement</strong><br />This agreement enters into force when you start
      use of the App and remains in force until terminated. The agreement may be terminated by both
      you and iBucket at any time by providing one month’s notice. This agreement terminates
      automatically and immediately in case you enter into bankruptcy, apply for a suspension of
      payments, your assets are seized, you pass away, or in case you enter into liquidation, legal
      dissolution or winding-up. After termination of the agreement (regardless of reason) you must
      cease all use of iBucket. In addition you must remove all copies (including backup copies) of
      iBucket from all computer systems under your control.
    </p>

    <p>
      <strong>Miscellaneous terms</strong><br />Dutch law applies to this end-user license
      agreement. Unless dictated otherwise by mandatory law, all disputes arising in connection with
      this agreement shall be brought before the competent Dutch court for the principal place of
      business of iBucket. A finding that any particular provision of this agreement is legally void
      shall not affect the validity of the entire agreement. In such a case the parties shall
      determine a replacement provision that is legally valid and approximates the intent of the
      offending provision as much as possible. iBucket may assign its rights and obligations under
      this agreement to a third party that acquires the relevant business or the copyrights to
      iBucket from it.
    </p>
  </ion-grid>
</ion-content>
